import { Injectable } from '@angular/core';
import { AppConstants } from 'app/app.constants';
import { normalizeStoredDraft, PassToPassDraft } from './calculator';

@Injectable({ providedIn: 'root' })
export class PassToPassStorageService {
  private key(userId: string): string {
    return `${AppConstants.USER_SCOPED_STORAGE_PREFIX}pass-to-pass.${userId}.draft`;
  }

  /** Returns null for anonymous users, missing drafts and unreadable storage. */
  load(userId: string | null): PassToPassDraft | null {
    if (!userId) {
      return null;
    }
    try {
      const value = localStorage.getItem(this.key(userId));
      if (!value) {
        return null;
      }
      return normalizeStoredDraft(JSON.parse(value));
    } catch {
      return null;
    }
  }

  /** Returns false when the draft could not be saved, e.g. storage blocked or full. */
  save(userId: string | null, draft: PassToPassDraft): boolean {
    if (!userId) {
      return false;
    }
    try {
      localStorage.setItem(this.key(userId), JSON.stringify(draft));
      return true;
    } catch {
      return false;
    }
  }
}
